import { useState } from "react";
import InputError from "../../../Components/InputError";
import InputLabel from "../../../Components/InputLabel";
import PrimaryButton from "../../../Components/PrimaryButton";
import TextInput from "../../../Components/TextInput";
import { useAuth } from "../../../context/AuthContext"; // Fetch user from AuthContext
import axios from "../../../axios";
import { Button } from '../../../shadcn/ui/button';

export default function UpdateProfileInformationForm({ className = "" }) {
  const { user, setUser } = useAuth(); // Fetch current user and update function
  const [data, setData] = useState({
    name: user.name || "",
    email: user.email || "",
  });
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErrors({});
    setStatus("");

    try {
      const response = await axios.put("/api/profile", data);
      setUser(response.data.user); // Update global user state
      setStatus("Το προφίλ ενημερώθηκε με επιτυχία.");
    } catch (error) {
      if (error.response && error.response.data.errors) {
        setErrors(error.response.data.errors); // Handle validation errors
      }
    }
  };

  return (
    <section className={className}>
      <header>
        <h2 className="text-lg font-medium text-gray-900">Πληροφορίες προφίλ</h2>
        <p className="mt-1 text-sm text-gray-600">
        Ενημερώστε τις πληροφορίες προφίλ και τη διεύθυνση email του λογαριασμού σας.
        </p>
      </header>

      <form onSubmit={submit} className="mt-6 space-y-6">
        <div>
          <InputLabel htmlFor="name" value="Όνομα" />
          <TextInput
            id="name"
            value={data.name}
            onChange={(e) => setData({ ...data, name: e.target.value })}
            className="mt-1 block w-full"
          />
          <InputError message={errors.name} className="mt-2" />
        </div>

        <div>
          <InputLabel htmlFor="email" value="Email" />
          <TextInput
            id="email"
            type="email"
            value={data.email}
            onChange={(e) => setData({ ...data, email: e.target.value })}
            className="mt-1 block w-full"
          />
          <InputError message={errors.email} className="mt-2" />
        </div>

        <div className="flex items-center gap-4">
          {/* <PrimaryButton>Αποθήκευση</PrimaryButton> */}
          <Button>Αποθήκευση</Button>
          {status && <p className="text-sm text-green-600">{status}</p>}
        </div>
      </form>
    </section>
  );
}
